import Decimal from 'decimal.js';
import { DateTime } from 'luxon';
import { FiCurrency, PricingByCurrency } from '../../types';
import { logInternalError } from '../errors';

export function centsToDollarsNumber(cents: number) {
  return new Decimal(Math.round(cents)).dividedBy(100).toNumber();
}

export function centsToDollars(cents: number, fixed = 2): string {
  return centsToDollarsNumber(cents).toFixed(fixed);
}

export function formattedCentsToDollars(cents: number): string {
  let dollars = centsToDollars(cents);

  // If it's a whole number, don't include the decimal point
  if (dollars.endsWith('.00')) {
    dollars = dollars.slice(0, -3);
  }

  // Add a dollar sign
  return `$${dollars}`;
}

export function dollarsToCents(dollars: number): number {
  return Math.round(new Decimal(dollars).times(100).toNumber());
}

export function isCreditCardExpired(month: number, year: number) {
  // Credit cards expire after the *end* of the month printed on the card, so we need to add 1 month
  const expirationDate = DateTime.fromObject({ month: month, year: year }).plus({ months: 1 });

  return DateTime.now() > expirationDate;
}

export function getLocalizedPricing(pricing: PricingByCurrency, currency: FiCurrency) {
  if (currency === FiCurrency.USD) {
    return pricing.USD;
  } else if (currency === FiCurrency.CAD && pricing.CAD !== undefined && pricing.CAD !== null) {
    return pricing.CAD;
  } else if (currency === FiCurrency.GBP && pricing.GBP !== undefined && pricing.GBP !== null) {
    return pricing.GBP;
  } else if (currency === FiCurrency.EUR && pricing.EUR !== undefined && pricing.EUR !== null) {
    return pricing.EUR;
  } else if (currency === FiCurrency.RON && pricing.RON !== undefined && pricing.RON !== null) {
    return pricing.RON;
  }
  const err = new Error(`Pricing unavailable for requested currency: ${currency}`);
  logInternalError(err);
  throw err;
}

export function stringToCurrency(input: string) {
  switch (input) {
    case 'USD':
      return FiCurrency.USD;
    case 'CAD':
      return FiCurrency.CAD;
    case 'GBP':
      return FiCurrency.GBP;
    case 'EUR':
      return FiCurrency.EUR;
    case 'RON':
      return FiCurrency.RON;
    default:
      return null;
  }
}
